import React from 'react'
import { FeaturedInWidget } from 'components/Widgets'

export const FeaturedIn: React.FC<React.PWC<unknown>> = () => (
  <FeaturedInWidget />
)
